import axios from "axios";

export const loadMedia = async ({
    path,
    setUrl,
    setLoading,
    elementId,
    conditionRender
  }: {
    path?: string;
    setUrl: (url: string) => void;
    setLoading: (loading: boolean) => void;
    elementId?: string;
    conditionRender?:boolean
  }) => {
    if (!path) return;
    setLoading(true);
    try {
      // Sử dụng URL trực tiếp thay vì blob để tận dụng browser caching
      const mediaUrl = `${process.env.REACT_APP_BACKEND_URL}${path}`;

      // Kiểm tra xem media có accessible không
      const response = await axios.head(mediaUrl, {
        validateStatus: (status) => status < 500, // Accept 2xx, 3xx, 4xx
      });

      if (response.status === 200 || response.status === 304) {
        // Sử dụng URL trực tiếp, browser sẽ tự động xử lý cache
        setUrl(mediaUrl);

        if (elementId) {
          const el = document.getElementById(elementId) as HTMLImageElement | null;
          if (el && conditionRender) el.src = mediaUrl;
        }
      } else {
        console.error(`Media not accessible: ${path}, status: ${response.status}`);
      }

      setLoading(false);
    } catch (error) {
      console.error(`Error loading ${path}:`, error);
      setLoading(false);
    }
  };